import { useContext, useMemo } from 'react'
import { Link } from 'react-router'
import { CheckCircleOutlined } from '@mui/icons-material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'

import { AppContext } from '../../providers/app-provider'
import { getFormattedDateTime } from '../../utils/helpers'
import SimpleTable from '../simple-table'

const columns = [
  {
    field: 'device',
    headerName: 'Devices',
    minWidth: 300,
    flex: 1,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <div>
        <Link to={`/tenant/${params.row.tenantId}/devices/${params.row.deviceId}`}>{params.row.name}</Link> • {params.row.uniqueId} • {params.row.nodeTypeName}
      </div>
    ),
  },
  {
    field: 'folderName',
    headerName: 'Current Folder',
    flex: 1,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => {
      if (params.row.folderId) return <Link to={`/tenant/${params.row.tenantId}/accounts/${params.row.folderId}`}>{params.row.folderName}</Link>
      return params.row.folderName
    },
  },
  {
    field: 'updated',
    headerName: 'Updated',
    width: 150,
    sortable: false,
  },
  {
    field: 'status',
    headerName: 'Activated',
    renderCell: ({ row: { status } }: GridRenderCellParams) =>
      status === 'Online' || status === 'Offline' || status === 'Pause' || status === 'Extra' ? (
        <CheckCircleOutlined color="success" />
      ) : (
        <CheckCircleOutlined color="disabled" />
      ),
    align: 'center',
    headerAlign: 'center',
    sortable: false,
  },
] satisfies GridColDef[]

const AccordionOrderDevicesTable = ({ expandedDetails }: { expandedDetails: IOrderItemExpanded }) => {
  const { tree, tenantId } = useContext(AppContext)
  const rows = useMemo(
    () =>
      expandedDetails.devices.map((d, idx) => ({
        id: idx,
        deviceId: d.deviceId,
        name: d.name,
        uniqueId: d.uniqueId,
        nodeTypeName: d.nodeTypeName,
        folderName: d?.folderName,
        folderId: tree?.[d.folderId] ? d.folderId : undefined,
        updated: d.updatedAt ? getFormattedDateTime(d.updatedAt, 'UTC', 'MM/dd/yyyy') : '-',
        status: d.isActivated,
        tenantId,
      })),
    [expandedDetails.devices, tenantId, tree]
  )

  return <SimpleTable columns={columns} rows={rows} />
}

export default AccordionOrderDevicesTable
